import httpClient from './httpClient'

const ENDPOINT = '/'
const BASEURL = 'https://idrissoulahbib.com'

const postContactMessage = (data) => httpClient.request({
  url: ENDPOINT,
  method: 'POST',
  baseURL: BASEURL,
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
export {
  postContactMessage
}
